import { getDaysDifference, isFirstSameOrBeforeSecond } from '../../utils/dateCalculations';

type DateValue = Parameters<typeof getDaysDifference>[0];

/**
 * "Heute"-Position auf der Schuljahres-Achse [start, end].
 * Prozentual statt Pixel/Refs -> responsiv und ohne Nachrechnen bei Resize.
 * Wird von allen Reihen (Blöcke, Fächercontainer) genutzt, damit Linie und Fläche
 * deckungsgleich auf derselben Achse liegen.
 *
 * - `started`:  Schuljahr hat begonnen (heute >= start) -> Fläche sichtbar.
 *               Bei komplett vergangenem Schuljahr -> Fläche deckt 100 % ab.
 * - `inRange`:  heute liegt innerhalb des Schuljahres -> Linie sichtbar.
 * - `percent`:  Position der Fläche/Linie, auf 0–100 % geclampt.
 */
export const getTodayPosition = (start: DateValue, end: DateValue) => {
  const now = new Date();
  const started = isFirstSameOrBeforeSecond(start, now);
  const inRange = started && isFirstSameOrBeforeSecond(now, end);
  const totalDays = getDaysDifference(start, end);
  const rawPercent = (getDaysDifference(start, now, false) / totalDays) * 100;
  const percent = Math.min(100, Math.max(0, rawPercent));
  return { started, inRange, percent };
};
